import React from "react";
import { createRoot } from "react-dom/client";
import Reading from "./Reading";

export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const reading = JSON.parse(element.dataset.reading);
  element.dataset.mounted = "true";
  createRoot(element).render(<Reading reading={reading} />);
}

function mountAll() {
  document.querySelectorAll("#tarot-reading").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
